import { render, staticRenderFns } from "./product_custom_config.vue?vue&type=template&id=454a2648&scoped=true"
import script from "./product_custom_config.vue?vue&type=script&lang=js"
export * from "./product_custom_config.vue?vue&type=script&lang=js"
import style0 from "./product_custom_config.vue?vue&type=style&index=0&id=454a2648&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a2648",
  null
  
)

export default component.exports